const EVENT_BASE = 'mim:';

export const EVENT_READY = `${EVENT_BASE}ready`;

export const EVENT_UPDATE_VARIANT_SELECTION = `${EVENT_BASE}update:variantSelection`;

/**
 * カートの更新
 */
export const EVENT_GLOBAL_UPDATE_CART = `${EVENT_BASE}global:updateCart`;

/**
 * カートに追加ボタンのクリック
 */
export const EVENT_CLICK_ADD_CART_BUTTON = `${EVENT_BASE}click:addCartButton`;

/**
 * variantの変更
 */
export const EVENT_CHANGE_VARIANT = `${EVENT_BASE}change:variant`;

/**
 * 数量の変更
 */
export const EVENT_CHANGE_QUANTITY = `${EVENT_BASE}change:quantity`;

/**
 * ビューの更新
 */
export const EVENT_UPDATE_VIEW = `${EVENT_BASE}updateView`;

/**
 * ビューの更新イベント
 */
export const EVENT_UPDATE_VIEW_EVENTS = ['DOMContentLoaded', EVENT_UPDATE_VIEW];

/**
 * ヒーローの次の画像へのイベント
 */
export const EVENT_HERO_NEXT = `${EVENT_BASE}hero:next`;

/**
 * ヒーローのドットの表示
 */
export const EVENT_HERO_DOT_SHOW_START = `${EVENT_BASE}hero:dot:show-start`;
export const EVENT_HERO_DOT_SHOW = `${EVENT_BASE}hero:dot:show`;
export const EVENT_HERO_DOT_SHOW_ALL_END = `${EVENT_BASE}hero:dot:show-all-end`;

/**
 * グローバルナビゲーションのトグル
 */
export const EVENT_GLOBAL_NAV_ACTIVATE = `${EVENT_BASE}global-nav:activate`;
export const EVENT_GLOBAL_NAV_DEACTIVATE = `${EVENT_BASE}global-nav:deactivate`;
export const EVENT_GLOBAL_NAV_TOGGLE_CLICK = `${EVENT_BASE}global-nav-toggle:click`;

/**
 * グローバルカートのトグル
 */
export const EVENT_GLOBAL_CART_ACTIVATE = `${EVENT_BASE}global-cart:activate`;
export const EVENT_GLOBAL_CART_DEACTIVATE = `${EVENT_BASE}global-cart:deactivate`;
export const EVENT_GLOBAL_CART_TOGGLE_CLICK = `${EVENT_BASE}global-cart-toggle:click`;

/**
 * スクロールロックのイベント
 */
export const EVENT_SCROLL_LOCK_ON_DISABLE_START = `${EVENT_BASE}scroll-lock:onDisableStart`;
export const EVENT_SCROLL_LOCK_ON_DISABLE = `${EVENT_BASE}scroll-lock:onDisable`;
export const EVENT_SCROLL_LOCK_ON_ENABLE_START = `${EVENT_BASE}scroll-lock:onEnableStart`;
export const EVENT_SCROLL_LOCK_ON_ENABLE = `${EVENT_BASE}scroll-lock:onEnable`;

/**
 * ヒーロースライドのトランジションイベント
 */
export const EVENT_HERO_SLIDE_TRANSITION_START = `${EVENT_BASE}hero:slide:transitionStart`;
export const EVENT_HERO_SLIDE_TRANSITION_END = `${EVENT_BASE}hero:slide:transitionEnd`;

/**
 * カートに追加ボタンのローディング開始
 */
export const EVENT_ADD_CART_START_LOADING = `${EVENT_BASE}addCart:startLoading`;

/**
 * カートに追加ボタンのローディング停止
 */
export const EVENT_ADD_CART_STOP_LOADING = `${EVENT_BASE}addCart:stopLoading`;

/**
 * スパリアスバリアントの変更
 */
export const EVENT_QUICK_CART_SPURIOUSLY_VARIANT_CHANGE = `${EVENT_BASE}quick-cart:spuriously:variantChange`;

/**
 * カート操作の開始
 */
export const EVENT_CART_OPERATION_START = `${EVENT_BASE}cart:operation:start`;

/**
 * カート操作の終了
 */
export const EVENT_CART_OPERATION_END = `${EVENT_BASE}cart:operation:end`;

/**
 * カートの内容読み込み完了（モーダル表示準備完了）
 */
export const EVENT_CART_CONTENT_LOADED = `${EVENT_BASE}cart:content:loaded`;
